<template>
  <BaseFormLayout
    :nonFieldErrors="formErrors.non_field_errors"
    :title="`Mark ${tripModule.trip} as Complete`"
  >
    <template #content>
      <v-row class="ma-0 border-light white rounded-lg">
        <v-col cols="12" md="3">
          <span class="text-body-2">{{ tripModule.trip }} Reference : </span>
          <span class="font-weight-bold">{{
            tripDetails.reference_number
          }}</span>
        </v-col>
        <v-col cols="12" md="3">
          <span class="text-body-2">{{ tripModule.trip }} Date : </span>
          <span class="font-weight-bold">{{ tripDetails.trip_date }}</span>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-bind="attrs"
                v-on="on"
                class="text-capitalize white--text font-weight-bold"
                x-small
                :color="$helper.tripStatusColor(tripDetails.status)"
              >
                {{ tripDetails.status }}
              </v-chip>
            </template>
            <span>{{ statusMapping.tripStatus }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <v-form
            v-model="isValid"
            @submit.prevent=""
            ref="markTripAsCompleteForm1"
          >
            <v-row class="ma-0">
              <v-col cols="4">
                <InputField
                  type="number"
                  v-model.number="tripDetails.trip_start_km"
                  min="0"
                  :label="`${tripModule.trip} Start KM*`"
                  :rules="[
                    (val) => !!val || `${tripModule.trip} Start KM is required`,
                    (val) =>
                      0 <= parseInt(val) || 'Negative value are not allowed',
                  ]"
                  :error-messages="formErrors.trip_start_km"
                  @input="
                    delete formErrors.trip_start_km;
                    $refs.markTripAsCompleteForm1.validate();
                  "
                />
              </v-col>
              <v-col cols="4">
                <InputField
                  type="number"
                  v-model.number="tripDetails.trip_end_km"
                  min="0"
                  :label="`${tripModule.trip} End KM*`"
                  :rules="[
                    (val) => !!val || `${tripModule.trip} End KM is required`,
                    (val) =>
                      0 <= parseInt(val) || 'Negative value are not allowed',
                    (val) =>
                      parseInt(val) > parseInt(tripDetails.trip_start_km) ||
                      `${tripModule.trip} End KM should be greater than ${tripModule.trip} Start KM`,
                  ]"
                  :error-messages="formErrors.trip_end_km"
                  @input="
                    delete formErrors.trip_end_km;
                    $refs.markTripAsCompleteForm1.validate();
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="ma-0 mt-4">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="orderList"
            item-key="id"
            disable-pagination
            :expanded.sync="expanded"
            hide-default-footer
            :show-expand="$helper.isCompanyHasItems()"
            class="elevation-3"
            :key="tableKey"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-3">
                <v-row class="ma-0 broder-light primary white--text">
                  <v-col cols="2" class="d-flex justify-center"
                    >Item Number</v-col
                  >
                  <v-col cols="3" class="d-flex justify-center"
                    >Item Description</v-col
                  >
                  <v-col cols="2" class="d-flex justify-center"
                    >Original Quantity</v-col
                  >
                  <v-col cols="2" class="d-flex justify-center"
                    >Pickedup Quantity</v-col
                  >
                  <v-col cols="2" class="d-flex justify-center"
                    >Delivered Quantity</v-col
                  >
                </v-row>
                <v-form v-model="isValid5" ref="markTripAsCompleteForm2">
                  <v-row
                    class="ma-0 broder-y-light"
                    v-for="(orderItem, index) in item.order_items"
                    :key="index"
                  >
                    <v-col cols="2" class="d-flex justify-center">{{
                      orderItem.item_no
                    }}</v-col>
                    <v-col cols="3" class="d-flex justify-center">{{
                      orderItem.item_description
                    }}</v-col>
                    <v-col cols="2" class="d-flex justify-center">{{
                      orderItem.original_quantity
                    }}</v-col>
                    <v-col cols="2" class="d-flex justify-center">
                      <InputField
                        v-if="item.status == 'partially_delivered' && item.current_status != 'Partially Delivered'"
                        type="number"
                        :dense="true"
                        v-model="orderItem.pickedup_quantity"
                        :max="orderItem.original_quantity"
                        min="1"
                        :rules="[
                          (val) => !!val || 'Pickedup Quantity is required',
                          (val) =>
                            parseInt(val) <=
                              parseInt(orderItem.original_quantity) ||
                            `Pickedup Quantity can't be more than original quantity!`,
                          (val) =>
                            parseInt(val) > 0 ||
                            `Pickedup Quantity can't be less than 1!`,
                        ]"
                        label="Pickedup Quantity*"
                        @input="$refs.markTripAsCompleteForm2.validate()"
                      />
                      <span v-else>{{ orderItem.pickedup_quantity }}</span>
                    </v-col>
                    <v-col cols="2" class="d-flex justify-center">
                      <InputField
                        v-if="item.status == 'partially_delivered' && item.current_status != 'Partially Delivered' "
                        type="number"
                        :dense="true"
                        v-model="orderItem.delivered_quantity"
                        :max="orderItem.original_quantity"
                        min="1"
                        :rules="[
                          (val) => !!val || 'Delivered Quantity is required',
                          (val) =>
                            parseInt(orderItem.pickedup_quantity) >=
                              parseInt(val) ||
                            `Delivered Quantity can't be more than Pickedup quantity`,
                          (val) =>
                            parseInt(val) <=
                              parseInt(orderItem.original_quantity) ||
                            `Delivered Quantity can't be more than original quantity!`,
                        ]"
                        label="Delivered Quantity*"
                        @input="onDeliveryQuantityChange(item.id)"
                      />
                      <span v-else>{{ orderItem.delivered_quantity }} </span>
                    </v-col>
                  </v-row>
                </v-form>
              </td>
            </template>
            <template v-slot:item.status="{ item, index }">
              <v-form v-model="isValid2" ref="markTripAsCompleteForm3">
                <td class="py-2">
                  <SelectField
                    v-if="
                      [
                        'assigned',
                        'enroute',
                        'pickedup',
                        'out for delivery',
                      ].indexOf(item.current_status.toLowerCase()) > -1
                    "
                    :dense="true"
                    :itemsList="
                      returnPossibleStatusList(
                        item.order_type,
                        item.current_status
                      )
                    "
                    :isClearable="false"
                    :isSearchRequired="false"
                    v-model="item.status"
                    :rules="[
                      (val) =>
                        !!val || `${statusMapping.orderStatus} is required`,
                    ]"
                    :label="`Select ${statusMapping.orderStatus}*`"
                    @change="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'status',
                        true
                      );
                      statusChanged($event, index);
                    "
                    :error-messages="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'status'
                      )
                    "
                  />
                  <span v-else class="text-capitalize">
                    {{ item.status.replaceAll("_", " ") }}
                  </span>
                </td>
              </v-form>
            </template>
            <template v-slot:item.execution_date="{ item, index }">
              <td class="pa-2">
                <v-form v-model="isValid3" ref="markTripAsCompleteForm4">
                  <InputField
                    v-if="item.status == 'unassigned'"
                    type="date"
                    :dense="true"
                    v-model="item.execution_date"
                    :min="returnToday()"
                    label="Select Execution Date*"
                    @change="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'execution_date',
                        true
                      )
                    "
                    :error-messages="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'execution_date'
                      )
                    "
                  />
                  <span v-else>{{ item.execution_date }}</span>
                </v-form>
              </td>
            </template>
            <template v-slot:item.action="{ item, index }">
              <td
                class="pa-2"
                v-if="
                  [
                    'cancelled',
                    'not_delivered',
                    'not_pickedup',
                    'partially_delivered',
                  ].indexOf(item.status) > -1 ||
                  (item.status == 'partially_delivered' &&
                    checkIfAnyItemIsPartiallyDelivered(item.order_items))
                "
              >
                <v-form v-model="isValid4" ref="markTripAsCompleteForm5">
                  <SelectField
                    :dense="true"
                    :isClearable="false"
                    :itemsList="reasonList[index]"
                    :disabled="
                      [
                        'Cancelled',
                        'Not Delivered',
                        'Not Pickedup',
                        'Partially Delivered',
                      ].includes(item.current_status)
                    "
                    v-model="item.reason"
                    :rules="[(val) => !!val || 'Reason is required']"
                    label="Reason*"
                    @change="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'reason',
                        true
                      )
                    "
                    :error-messages="
                      errorInSubArrayHandler(
                        formErrors,
                        'trip_orders',
                        index,
                        'reason'
                      )
                    "
                  />
                </v-form>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </template>
    <template #actions>
      <v-btn
        color="primary"
        depressed
        :disabled="!masterIsValid"
        @click="submitForm()"
      >
        Submit
      </v-btn>
    </template>
  </BaseFormLayout>
</template>

<script>
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { bus } from "@/main";
import { returnToday, errorInSubArrayHandler } from "@/utils/functions";
import { statusMapping, tripModule } from "@/utils/moduleMapping";

export default {
  components: { BaseFormLayout },
  data() {
    return {
      statusMapping,
      tripModule,
      returnToday,
      errorInSubArrayHandler,
      isValid: true,
      isValid2: true,
      isValid3: true,
      isValid4: true,
      isValid5: true,
      formErrors: {},

      expanded: [],

      deliveryOrderStatusList: [
        { text: "Partially Delivered", value: "partially_delivered" },
        { text: "Cancelled", value: "cancelled" },
        { text: "Delivered", value: "delivered" },
        { text: "Not Delivered", value: "not_delivered" },
        { text: "Unassigned", value: "unassigned" },
      ],
      pickupOrderStatusList: [
        { text: "Cancelled", value: "cancelled" },
        { text: "Delivered", value: "delivered" },
        { text: "Not Delivered", value: "not_delivered" },
        { text: "Not Pickedup", value: "not_pickedup" },
        { text: "Unassigned", value: "unassigned" },
      ],
      orderList: [],
      reasonList: [],

      tripDetails: {},
      headers: [
        {
          value: "data-table-expand",
          text: "#",
        },
        {
          value: "reference_number",
          text: "Reference Number",
          sortable: false,
        },
        {
          value: "customer_name",
          text: "Customer Name",
          sortable: false,
        },
        {
          text: "Order Type",
          value: "order_type",
          sortable: false,
          cellClass: "text-capitalize",
        },
        {
          value: "address",
          text: "Address",
          sortable: false,
          cellClass: "text-truncate max-200",
        },
        {
          value: "current_status",
          text: "Current Status",
          sortable: false,
        },
        {
          value: "status",
          text: "Status",
          sortable: false,
        },
        {
          value: "execution_date",
          text: "Execution Date",
          sortable: false,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
        },
      ],
      itemsHeaders: [
        {
          text: "Item Number",
          value: "item_no",
          sortable: false,
        },
        {
          text: "Description",
          value: "item_description",
          sortable: false,
        },
        {
          text: "Sale Quantity",
          value: "original_quantity",
          sortable: false,
        },
        {
          text: "Delivered Quantity",
          value: "delivered_quantity",
          sortable: false,
        },
        {
          text: "Picked Up Quantity",
          value: "pickedup_quantity",
          sortable: false,
        },
      ],

      tableKey: 0,
    };
  },
  computed: {
    masterIsValid() {
      return (
        this.isValid &&
        this.isValid2 &&
        this.isValid3 &&
        this.isValid4 &&
        this.isValid5
      );
    },
  },
  methods: {
    onDeliveryQuantityChange(id) {
      this.$refs.markTripAsCompleteForm2.validate();
      let index = this.orderList.findIndex((v) => v.id == id);
      this.errorInSubArrayHandler(
        this.formErrors,
        "trip_orders",
        index,
        "status",
        true
      );
    },
    checkIfAnyItemIsPartiallyDelivered(items) {
      return items.filter((orderItem) => {
        if (orderItem.pickedup_quantity != orderItem.delivered_quantity) {
          return orderItem;
        }
      }).length > 0
        ? true
        : false;
    },
    statusChanged(status, index) {
      if (
        status == "partially_delivered" ||
        status == "cancelled" ||
        status == "not_delivered" ||
        status == "not_pickedup"
      ) {
        this.reasonList[index] = [];

        if (
          "reason" in this.orderList[index] &&
          [
            "partially delivered",
            "not delivered",
            "cancelled",
            "not pickedup",
          ].includes(this.orderList[index].current_status)
        ) {
          delete this.orderList[index].reason;
        }

        if (status == "partially_delivered") {
          this.expanded.push(this.orderList[index]);
          this.getReasonList({ search: "partially delivered" }, index);
        } else {
          this.getReasonList({ search: status.replace(/_/g, " ") }, index);
        }
      } else {
        this.isValid4 = true;
        let itemArr = this.orderList[index]["order_items"];
        let newArr = itemArr.map((item) => {
          return {
            ...item,
            pickedup_quantity: item.original_quantity,
            delivered_quantity: item.original_quantity,
          };
        });
        this.orderList[index]["order_items"] = newArr;
      }
    },
    getReasonList(params = {}, index) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        limit: "all",
      };
      this.$api.fieldConfiguration
        .getFieldConfigurationList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.reasonList[index] = res.data.map((reason) => reason.name);
          this.tableKey++;
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    returnPossibleStatusList(orderType, orderStatus) {
      return orderType == "delivery"
        ? this.deliveryOrderStatusList
        : orderType == "pickup" && orderStatus == "pickedup"
        ? this.pickupOrderStatusList.splice(
            this.pickupOrderStatusList.findIndex("not_pickedup"),
            1
          )
        : this.pickupOrderStatusList;
    },
    submitForm() {
      bus.$emit("showLoader", true);
      let payload = {
        ...this.tripDetails,
        trip_orders: this.orderList,
      };
      this.$api.trip
        .updateMarkTripAsCompleteData(this.tripDetails.id, payload)
        .then(() => {
          this.$router.back();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.formErrors = err.data;
          bus.$emit("showLoader", false);
        });
    },
    getMarkTripAsCompleteData(id) {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getMarkTripAsCompleteData(id)
        .then((res) => {
          this.expanded = [];
          this.tripDetails = res.data;
          this.orderList = this.tripDetails.trip_orders.map((order, index) => {
            this.expanded.push(true);
            return {
              ...order,
              status: order.status,
            };
          });

          setTimeout(() => {
            this.tripDetails.trip_orders.map((order, index) => {
              this.statusChanged(order.status, index);
            });
          }, 500);

          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    if (
      this.$route.params &&
      this.$route.params.id &&
      !isNaN(this.$route.params.id)
    ) {
      this.getMarkTripAsCompleteData(this.$route.params.id);
      let inter = setInterval(() => {
        let instance = this.$refs.markTripAsCompleteForm;
        if (instance) {
          clearInterval(inter);
          instance.resetValidation();
        }
      }, 100);
    }
  },
};
</script>

<style>
.max-200 {
  max-width: 20vw;
}
</style>
